import React, { useState } from "react"
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    FormGroup,
    Label,
    Input,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    CardFooter,
    Button,
    Row,
    Col
} from "reactstrap";
import MembersService from "services/staff.service"

function CreateMenber() {
    const [account, setAccount] = useState('')
    const [email, setEmail] = useState('')
    const [fullName, setFullName] = useState('')
    const [password, setPassword] = useState('')

    function createMember() {
        if (!account || !password || !email || !fullName) {
            Swal.fire({
                icon: 'error',
                title: 'Lỗi',
                text: 'Vui lòng điền đầy đủ thông tin',
            });
            return;
        }

        Swal.fire({
            title: 'Xác nhận',
            text: 'Bạn có muốn thêm tài khoản này?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Có',
            cancelButtonText: 'Không'
        }).then((result) => {
            if (result.value) {
                MembersService.createMember(memberInformationWillCreate())
                    .then(response => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Thành công',
                            text: response.data.message || "Tạo tài khoản thành công",
                            showConfirmButton: true,
                        }).then(res => {
                            window.location.reload();
                        });
                    })
                    .catch(error => {
                        Swal.fire({
                            icon: 'error',
                            title: 'Lỗi',
                            text: error.response?.data?.message || "Có lỗi xảy ra khi tạo tài khoản",
                        });
                    });
            }
        });
    }

    function memberInformationWillCreate() {
        return {
            "username": account,
            "password": password,
            "email": email,
            "fullname": fullName,
        }
    }

    return (
        <Row>
            <Col md="12">
                <Card style={{ backgroundColor: '#fff', borderRadius: '20px', border: 'none', boxShadow: '0 4px 20px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
                    <CardHeader style={{ background: 'linear-gradient(135deg, #198754 0%, #0f5132 100%)', padding: '18px 24px', border: 'none', borderRadius: '20px 20px 0 0', display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <i className="fas fa-user-plus" style={{ fontSize: '32px', color: '#fff', opacity: 0.9 }}></i>
                        <div style={{ lineHeight: '1.3' }}>
                            <Label style={{ fontSize: '18px', color: '#fff', fontWeight: '700', marginBottom: '0', display: 'block' }}>Thêm tài khoản mới</Label>
                            <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>Tạo nhân viên mới</span>
                        </div>
                    </CardHeader>
                    <CardBody style={{ padding: '20px 24px' }}>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="account">Tài khoản</Label>
                                    <Input
                                        value={account}
                                        id="account"
                                        placeholder="Nhập tên tài khoản"
                                        onChange={(e) => setAccount(e.target.value)}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="password">Mật khẩu</Label>
                                    <Input
                                        type="password"
                                        value={password}
                                        id="password"
                                        placeholder="Nhập mật khẩu"
                                        onChange={(e) => setPassword(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label for="email">Email</Label>
                                    <Input
                                        type="email"
                                        value={email}
                                        id="email"
                                        placeholder="Nhập email"
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label for="fullname">Họ và tên</Label>
                                    <Input
                                        value={fullName}
                                        id="fullname"
                                        placeholder="Nhập họ và tên"
                                        onChange={(e) => setFullName(e.target.value)}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </CardBody>
                    <CardFooter style={{ padding: '20px 24px' }}>
                        <Row>
                            <Col className="text-center">
                                <Button
                                    color="primary"
                                    style={{ borderRadius: '20px', padding: '8px 20px' }}
                                    onClick={() => createMember()}>
                                    <i className="fas fa-plus" style={{ marginRight: '5px' }}></i> Thêm tài khoản
                                </Button>
                            </Col>
                        </Row>
                    </CardFooter>
                </Card>
            </Col>
        </Row>
    )
}

export default CreateMenber